import { Alert, Spin, Table, Tabs, Tag } from 'antd';
import React, { useEffect, useState } from 'react';

import { Container, StyledTitle } from './styles';

const { TabPane } = Tabs;

export default function About() {
  const [frontendData, setFrontendData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  function parseChangelogTxt(txt) {
    return txt
      .split('\n')
      .filter((line) => line && !line.startsWith('#'))
      .map((line) => {
        const [date, type, description, author, commit] = line.split(',');
        if (!commit) return null;
        return { date, type, description, author, commit };
      })
      .filter(Boolean);
  }

  useEffect(() => {
    fetch('/frontend-changelog.txt')
      .then((res) => res.text())
      .then((txt) => setFrontendData(parseChangelogTxt(txt)))
      .catch((err) => setError(`Could not load changelog. ${err.message}`))
      .finally(() => setLoading(false));
  }, []);

  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      width: 110,
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width: 90,
      render: (type) => {
        let color;
        switch (type) {
          case 'feat':
            color = 'green';
            break;
          case 'fix':
            color = 'volcano';
            break;
          default:
            color = 'blue';
        }
        return (
          <Tag color={color} style={{ fontWeight: 500 }}>
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </Tag>
        );
      },
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: 400,
    },
    {
      title: 'Author',
      dataIndex: 'author',
      key: 'author',
      width: 160,
    },
    {
      title: 'Commit',
      dataIndex: 'commit',
      key: 'commit',
      width: 100,
      render: (commit) => <span style={{ fontFamily: 'monospace' }}>{commit}</span>,
    },
  ];

  function renderContent(loading, error, data) {
    if (loading) return <Spin />;
    if (error) return <Alert type="error" message={error} />;
    return <Table columns={columns} dataSource={data} rowKey="commit" pagination={{ pageSize: 10 }} bordered />;
  }

  return (
    <Container>
      <StyledTitle level={2}>About & Changelog</StyledTitle>
      <Tabs defaultActiveKey="frontend">
        <TabPane tab="Frontend" key="frontend">
          {renderContent(loading, error, frontendData)}
        </TabPane>
        <TabPane tab="Backend" key="backend">
          <Alert type="info" message="Backend changelog will be shown here soon." />
        </TabPane>
      </Tabs>
    </Container>
  );
}
